import React, { Component } from 'react'
import { connect } from 'react-redux';
import {bindActionCreators} from "redux";

import {strings, CCUtils, CCUIUtils, CCTransactionItem, DataActionTypes as DataAT, CCActions, Constants, CCModalLayout, CCListView} from "../../cc-imports";
import {FirebaseUtils} from "../../lib/index";
// import './transactions.css'
import CCActivityIndicator from "../../components/CCActivityIndicator/CCActivityIndicator";
import './../../styles/css/screens/Transactions/transactions.css'

class Transactions extends Component {

    static propTypes = {}
    static defaultProps = {}

    constructor(props) {
        super(props)
        this.state = {
            skip : 0,
            pending :false
        }
        this._fetchTransactions=this._fetchTransactions.bind(this);
        this._autoRefresh=this._autoRefresh.bind(this);
        this._manualRefresh=this._manualRefresh.bind(this);
        this._paginate=this._paginate.bind(this);
    }

    _fetchTransactions(type) {
        const {userId, actions, pages} = this.props;
        if(this.state.pending==true) return;

        this.setState({pending : true},()=>{
            FirebaseUtils.getIdTokenWhenAuthChanged((idToken) => {
                var page = pages[userId] == undefined ? 0 : pages[userId];
                var skip = (type == DataAT.AUTO_REFRESH || type == DataAT.MANUAL_REFRESH) ? 0 : page;
                var limit = (type == DataAT.AUTO_REFRESH || type == DataAT.MANUAL_REFRESH) ? page * 20 : 20;

                if (userId) {
                    actions.fetchTransactions(idToken, userId, skip, limit, type).then(()=>{
                        this.setState({pending : false});
                    }).catch(()=>{
                        this.setState({pending : false});
                    })
                }

            })
        })


    }

    _autoRefresh() {
        this._fetchTransactions(DataAT.AUTO_REFRESH);
    }

    _manualRefresh() {
        this._fetchTransactions(DataAT.MANUAL_REFRESH);
    }

    _paginate() {
        const {reqStatus} = this.props;
        if (reqStatus != Constants.reqStatus.FAI && reqStatus != Constants.reqStatus.COM) {
            this._fetchTransactions(DataAT.PAGINATE);
        }
    }

    _autoRefresh() {
        this._fetchTransactions(DataAT.AUTO_REFRESH);
    }

    _manualRefresh() {
        this._fetchTransactions(DataAT.MANUAL_REFRESH);
    }

    _paginate() {
        const {reqStatus} = this.props;
        if (reqStatus != Constants.reqStatus.FAI && reqStatus != Constants.reqStatus.COM) {
            this._fetchTransactions(DataAT.PAGINATE);
        }
    }

    componentDidMount() {
        if (this.props.userId) {
            this._fetchTransactions(DataAT.GET);
        }
    }

    componentWillUnmount() {
    }


    componentWillReceiveProps(nextProps) {
        if(CCUtils.userUpdated(this.props.user, nextProps.user)){
            this._fetchTransactions(DataAT.GET);
        }
    }


    render() {
        const {reqStatus, type, userId, byUserId, byId} = this.props;

        var transactions = byUserId[userId];
        return (

                <div  style={{flex: 1}}>
                    <div className="flex-container transaction-heading-container">
                        <h2 className="transaction_heading_title">{strings('transactions')}</h2>
                    </div>
                    {
                        (transactions && transactions.length >0) ?
                            <CCListView data={transactions} onEndReachedThreshold={2} onEndReached={this._paginate} endReached={reqStatus==Constants.reqStatus.COM || reqStatus==Constants.reqStatus.FAI} renderItem={(trnId, index)=>{
                                const trans = byId[trnId];
                                return (<CCTransactionItem transaction={trans} key={trnId}></CCTransactionItem>);
                            }}/>
                            :
                            CCUIUtils.getEmptyListItem(reqStatus)
                    }
                </div>
        )
    }
}

export default connect(state => ({
        modals: state.modals,
        user: state.user,
        byId: state.transactions.byId,
        byUserId : state.transactions.byUserId,

        pages : state.transactions.pages,
        userId : state.user.user.id,
        random : state.transactions.random,
        type : state.transactions.type,
        reqStatus : state.transactions.reqStatus
    }),
    (dispatch) => ({
        actions: bindActionCreators({...CCActions}, dispatch),
        dispatch: dispatch
    })
)(Transactions);


// WEBPACK FOOTER //
// ./src/app/screens/Transactions/Transactions.js